export default __webpack_public_path__ + "static/media/dashboard.d0ebed89.svg";